import React from 'react';

export function Toaster() {
  return null;
}
